import { HTMLAttributes } from "react"

export default function Reflex(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2347_5902)">
        <path
          d="M5 48V0H43.4V19.2H33.8V9.59999H14.6V19.2H33.8V28.8H14.6V48H5ZM33.8 48V28.8H43.4V48H33.8Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_2347_5902">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
